// extracted by mini-css-extract-plugin
export default {"r_l":"_6413ac2a88 f1be677b8a","t":"_0b4997168d"};